import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'rcp-list-container',
  template: `
    <div class="rcp-list-container" [class.responsive]="type() === 'responsive'">
      <ng-content />
    </div>
  `,
  styles: `
    :host {
      display: block;
      container-name: rcp-list-container;
      container-type: inline-size;
    }

    .rcp-list-container {
      columns: 1;
      column-gap: var(--list-item-spacing);
    }

    @container rcp-list-container (width > 576px) {
      /* small devices (phones) */
      .rcp-list-container.responsive {
        columns: 1;
      }
    }
    @container rcp-list-container (width > 768px) {
      /* medium devices (tablets) */
      .rcp-list-container.responsive {
        columns: 2;
      }
    }
    @container rcp-list-container (width > 992px) {
      /* large devices (desktops) */
      .rcp-list-container.responsive {
        columns: 3;
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ListContainerComponent {
  readonly ngClass = input();
  readonly ngStyle = input();

  readonly type = input<'responsive' | 'vertical'>('responsive');
}
